import { parsePhonetoLink } from 'utils/getPhone';

export const PHONE = '91 290 77 88';
export const PHONE_LINK = parsePhonetoLink(PHONE);

export const PHONE_ONLINE = '91 060 66 44';
export const PHONE_ONLINE_LINK = parsePhonetoLink(PHONE_ONLINE);

export const PHONE_BUNDLE = '91 943 44 00';
export const PHONE_BUNDLE_LINK = parsePhonetoLink(PHONE_BUNDLE);

// QUERY SEARCH

export const QUERY_FULL_REPAYMEMT = 'fullRepayment=true';
export const QUERY_BACK_ROUTE = 'backRoute';
export const QUERY_PARTIAL_AMOUNT = 'partialAmount';
export const QUERY_EXTENSION = 'extension';
export const QUERY_PAYMENT_METHOD = 'paymentMethod';
export const QUERY_BIZUM = 'paymentMethod=bizum';
export const QUERY_BIZUM_VALUE = 'bizum';
export const QUERY_CARD_ADDED = 'card';

// OTHER
export const MIN_PARTIAL_PAYMENT_VALUE = 10;

// BUNDLE CONSTANTS

export const PENDING_BUNDLE_FEE = 'PENDING_BUNDLE_FEE';
export const PENDING_BUNDLE_HOLD_PERIOD = 'PENDING_BUNDLE_HOLD_PERIOD';

// MOBILE STORE

export const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=es.vivus.app.react&utm_source=dashboard&utm_medium=banner&utm_campaign=app_download';
export const APPLE_STORE =
  'https://apps.apple.com/es/app/vivus-es-pr%C3%A9stamos-r%C3%A1pidos/id1545891186?utm_source=dashboard&utm_medium=banner&utm_campaign=app_download';

// MOBILE WIDTHS

// Associated to the "breakpoints" in variables.module.scss
export const isMobileWidth = () => {
  return window.screen.width < 768;
};

// PARAMS

export const ERROR_ATTEMPTS_PARAM = 'error';
export const PARAM_CARD_FETCH = 'cardFetch';
export const PARAM_AUTOREPAY = 'autorepay';
export const PARAM_MOBILE_BTN_CLICKED = 'mobileBtnClicked';

// PRODUCT_NUMBER

export const PRODUCT_NUMBER_PARAM = 'clientProductNameLogin';

export const PRODUCT_NUMBER_ONLINE = 'VIVUS_ONLINE'; // Product 6
export const PRODUCT_NUMBER_IL = 'VIVUS_IL'; // Product 7
export const PRODUCT_NUMBER_SPL = 'VIVUS_SPL'; // Product 8

// SESSION STORAGE CONSTANTS
export const INSURANCE_POLICY = 'insurancePolicy';
export const INSURANCE_POLICY_ENABLED_ONCE = 'insurancePolicyEnabledOnce';
export const INSURANCE_POLICY_SKIPPED = 'insurancePolicySkipped';
